import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=1c796f16"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c796f16')) {
      api.createRecord('1c796f16', component.options)
    } else {
      api.reload('1c796f16', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=1c796f16", function () {
      api.rerender('1c796f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Logo.vue"
export default component.exports